import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allQuestionnaires: [],
  allQuestions: [],
  allSubQuestions: [],
  allOptions: [],
  allSubQuestionOptions: [],
  allOnBoardingTemplates: [],
  selectedQuestionnaire: null,
  selectedQuestion: null,
  selectedSubQuestion: null,
  error: null,
  isLoading: false,
  isLoadingQuestionnaire: false,
  isLoadingResponse: false,
  isLoadingRemediationRequest: false,
  onBoardingFormsForCustomer: [],
  responseForOnBoardingForm: [],
  customerOnBoardingTemplate: [],
  subQuestions: [],
  possibleSollutionForCustomerQuesries: [],
  isLoadingPossibleSollutionForCustomerQueries: false,
  sollutionsForQuestion: [],
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    startQuestionnaire: (state) => {
      state.isLoadingQuestionnaire = true;
      state.error = null;
    },
    startRemediationRequest: (state) => {
      state.isLoadingRemediationRequest = true;
      state.error = null;
    },
    setIsLoadingRemediationRequest: (state, action) => {
      state.isLoadingRemediationRequest = action.payload;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isLoadingResponse = false;
      state.isLoadingQuestionnaire = false;
    },
    setAllQuestionnaires: (state, action) => {
      state.allQuestionnaires = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setAllQuestions: (state, action) => {
      state.allQuestions = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setAllSubQuestions: (state, action) => {
      state.allSubQuestions = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setAllOptions: (state, action) => {
      state.allOptions = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setAllSubQuestionOptions: (state, action) => {
      state.allSubQuestionOptions = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setSelectedQuestionnaire: (state, action) => {
      state.selectedQuestionnaire = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setSelectedQuestion: (state, action) => {
      state.selectedQuestion = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setSelectedSubQuestion: (state, action) => {
      state.selectedSubQuestion = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setOnBoardingFormsForCustomer: (state, action) => {
      state.onBoardingFormsForCustomer = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setResponseForOnBoardingForm: (state, action) => {
      state.responseForOnBoardingForm = action.payload;
      state.isLoading = false;
      state.isLoadingResponse = false;
      state.isLoadingQuestionnaire = false;
    },
    setAllOnBoardingTemplates: (state, action) => {
      state.allOnBoardingTemplates = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setCustomerOnBoardingTemplate: (state, action) => {
      state.customerOnBoardingTemplate = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setEscalationPath: (state, action) => {
      state.escalationPath = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setSubQuestions: (state, action) => {
      state.subQuestions = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    setPossibleSollutionForCustomerQuesries: (state, action) => {
      state.possibleSollutionForCustomerQuesries = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
      state.isLoadingPossibleSollutionForCustomerQueries = false;
    },
    setSollutionsForQuestion: (state, action) => {
      state.sollutionsForQuestion = action.payload;
      state.isLoading = false;
      state.isLoadingQuestionnaire = false;
    },
    startLoadingPossibleSollutionForCustomerQueries: (state) => {
      state.isLoadingPossibleSollutionForCustomerQueries = true;
    },
    stopLoadingPossibleSollutionForCustomerQueries: (state) => {
      state.isLoadingPossibleSollutionForCustomerQueries = false;
    },
    resetOnboarding: () => initialState,
  },
});

export const {
  start,
  setIsLoading,
  startQuestionnaire,
  setLoading,
  setReducerError,
  startRemediationRequest,
  setIsLoadingRemediationRequest,
  setAllQuestionnaires,
  setAllQuestions,
  setAllSubQuestions,
  setAllOptions,
  setAllSubQuestionOptions,
  setAllOnBoardingTemplates,
  setSelectedQuestionnaire,
  setSelectedQuestion,
  setOnBoardingFormsForCustomer,
  setResponseForOnBoardingForm,
  resetOnboarding,
  setCustomerOnBoardingTemplate,
  setEscalationPath,
  setSelectedSubQuestion,
  setSubQuestions,
  setPossibleSollutionForCustomerQuesries,
  startLoadingPossibleSollutionForCustomerQueries,
  stopLoadingPossibleSollutionForCustomerQueries,
  setSollutionsForQuestion,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
